<template>
  <v-layout row wrap justify-center pa-3>
      <v-flex sm11 xs11 md12 lg12>
          <v-data-table :headers="headers" @click:row="editRationBalance"
              no-results-text="Nenhum registro encontrado" :items-per-page="5"
              :must-sort="true" :items="listConsumoLote" color="secondary"
              loading-text="Carregando registros...aguarde">
              <template v-slot:item.data="{ item }">
                  {{ item.data | dateIsoToLocale }}
              </template>
          </v-data-table>
      </v-flex>
  </v-layout>
</template>

<script>

import _ from 'lodash'
import { dateIsoToLocal } from '@/filters/utils'

var cmp

export default {
  data() {
		return {
			headers: [
        { text: "Dias", value: "diaDoLote", sortable: false },
        { text: "Diário Realizado", value: "consumoPorAnimalPorDia" },
        { text: "Diário Desejado", value: "consumoEsperadoPorAnimalPorDia" },
				{ text: "Acc. Real", value: "consumoAcumuladoPorAnimal" },
				{ text: "Acc. Desejado", value: "consumoAcumuladoEsperadoPorAnimal" },
        { text: "Desvio (%)", value: "desvio" },
        { text: "Saldo de Animais", value: "saldoAnimais" },
        { text: "Data", value: "data" },
        { text: "Estoque", value: "qtRacao" },
        { text: "Saldo Informado", value: "saldoInformado" },
        { text: "Consumo", value: "consumo" },
			],
			listConsumoLote: [],
      atualItem: {},
		}
  },
  props:{
      values: Array,
      isLoading: {
        type: Boolean,
        default: false
      }
  },
  methods: {
    dateIsoToLocal,
    notifyInteraction: _.throttle( () => {
      cmp.$ga.event('Componente', 'TabelaConsumo', cmp.$keycloak.tokenParsed.preferred_username, cmp.$route.params.id)
    }, 2000),
    loadRationConsumptionExpected() {
      var context = this
      this.listConsumoLote = []
      if (this.values != null)
      {
        context.listConsumoLote = this.values
      }
    },
    editRationBalance(item) {
      this.$emit('editRationBalance', item)
    },
    
  },
  computed: {
  },
  mounted() {
    cmp = this
    this.loadRationConsumptionExpected()
  },
  watch:{
		values (val) {
			if (val)
			{
				this.loadRationConsumptionExpected()
			}
		}
	},
}
</script>

<style>
  .marginTabel {
    margin-left: 1%; 
    margin-right: 1%;
  }
</style>
